var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import MaterialRadioGroup from "@mui/material/RadioGroup";
// styles
import "./radioGroup.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-radioGroup",
};
const RadioGroup = (_a) => {
    var { className, children, label, labelId, defaultValue, row, helperText } = _a, rest = __rest(_a, ["className", "children", "label", "labelId", "defaultValue", "row", "helperText"]);
    const classList = classNames("tecma-radioGroup", className);
    return (_jsxs(FormControl, { className: classList, children: [label && _jsx(FormLabel, { id: labelId, children: label }), _jsx(MaterialRadioGroup, Object.assign({ "aria-labelledby": labelId, defaultValue: defaultValue, name: "radio-buttons-group", row: row }, rest, { children: children })), helperText && _jsx("span", { className: "helper-text", children: helperText })] }));
};
RadioGroup.defaultProps = defaultProps;
export default React.memo(RadioGroup);
